export default function RobotSvg() {
  return (
    <svg className="w-32 h-32 sm:w-36 sm:h-36 drop-shadow-2xl filter" viewBox="0 0 200 220" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Dynamic Shadow */}
      <ellipse cx="100" cy="200" rx="45" ry="10" fill="url(#shadowGradient)">
        <animate attributeName="rx" values="45;50;45" dur="3s" repeatCount="indefinite" />
        <animate attributeName="opacity" values="0.2;0.3;0.2" dur="3s" repeatCount="indefinite" />
      </ellipse>

      {/* Main Robot Group with Hover */}
      <g>
        <animateTransform
          attributeName="transform"
          type="translate"
          values="0,0; 0,-6; 0,0"
          dur="2.5s"
          repeatCount="indefinite"
        />

        {/* Robot Body - White & Black */}
        <g filter="url(#robotShadow)">
          <rect x="75" y="80" width="50" height="60" rx="8" fill="url(#robotBodyGradient)" stroke="#1f2937" strokeWidth="2.5" />
          <line x1="75" y1="95" x2="125" y2="95" stroke="#4b5563" strokeWidth="1.5" opacity="0.5" />
          <line x1="75" y1="110" x2="125" y2="110" stroke="#4b5563" strokeWidth="1.5" opacity="0.5" />
          <line x1="75" y1="125" x2="125" y2="125" stroke="#4b5563" strokeWidth="1.5" opacity="0.5" />
          <rect x="85" y="90" width="30" height="25" rx="4" fill="url(#panelGradient)" opacity="0.8" />

          {/* Center power core */}
          <circle cx="100" cy="102" r="8" fill="#1f2937" stroke="#f3f4f6" strokeWidth="2">
            <animate attributeName="opacity" values="1;0.6;1" dur="2s" repeatCount="indefinite" />
          </circle>
          <circle cx="100" cy="102" r="5" fill="url(#coreGradient)">
            <animate attributeName="r" values="5;6;5" dur="2s" repeatCount="indefinite" />
          </circle>
          <circle cx="98" cy="100" r="2" fill="#fff" opacity="0.9">
            <animate attributeName="opacity" values="0.9;0.5;0.9" dur="2s" repeatCount="indefinite" />
          </circle>

          {/* Side vents */}
          <g opacity="0.7">
            <line x1="80" y1="120" x2="80" y2="130" stroke="#4b5563" strokeWidth="2" strokeLinecap="round" />
            <line x1="84" y1="120" x2="84" y2="130" stroke="#4b5563" strokeWidth="2" strokeLinecap="round" />
            <line x1="120" y1="120" x2="120" y2="130" stroke="#4b5563" strokeWidth="2" strokeLinecap="round" />
            <line x1="116" y1="120" x2="116" y2="130" stroke="#4b5563" strokeWidth="2" strokeLinecap="round" />
          </g>

          {/* Shoulder joints */}
          <circle cx="72" cy="85" r="6" fill="#1f2937" stroke="#f3f4f6" strokeWidth="2" />
          <circle cx="128" cy="85" r="6" fill="#1f2937" stroke="#f3f4f6" strokeWidth="2" />
        </g>

        {/* Robot Neck connector */}
        <rect x="92" y="68" width="16" height="14" rx="3" fill="#374151" stroke="#1f2937" strokeWidth="2" />
        <line x1="95" y1="70" x2="95" y2="80" stroke="#6b7280" strokeWidth="1.5" />
        <line x1="105" y1="70" x2="105" y2="80" stroke="#6b7280" strokeWidth="1.5" />

        {/* Robot Head */}
        <g filter="url(#robotShadow)">
          <rect x="75" y="25" width="50" height="45" rx="10" fill="url(#robotHeadGradient)" stroke="#1f2937" strokeWidth="3" />
          <path d="M78 30 L85 25 L115 25 L122 30 Z" fill="#374151" opacity="0.8" />
          <rect x="70" y="40" width="8" height="15" rx="2" fill="#1f2937" stroke="#4b5563" strokeWidth="1.5" />
          <rect x="122" y="40" width="8" height="15" rx="2" fill="#1f2937" stroke="#4b5563" strokeWidth="1.5" />

          {/* Antenna */}
          <line x1="100" y1="25" x2="100" y2="15" stroke="#4b5563" strokeWidth="2.5" strokeLinecap="round" />
          <circle cx="100" cy="13" r="3" fill="#ef4444">
            <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite" />
          </circle>
          <circle cx="100" cy="13" r="5" fill="#ef4444" opacity="0.3">
            <animate attributeName="r" values="5;7;5" dur="1.5s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.3;0;0.3" dur="1.5s" repeatCount="indefinite" />
          </circle>

          <rect x="85" y="32" width="30" height="8" rx="2" fill="url(#panelGradient)" opacity="0.6" />

          {/* Robot Eyes */}
          <g>
            <rect x="82" y="45" width="12" height="8" rx="2" fill="#1f2937" />
            <rect x="84" y="47" width="8" height="4" rx="1" fill="#06b6d4">
              <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite" />
            </rect>
            <rect x="85" y="48" width="3" height="2" fill="#fff" opacity="0.8" />

            <rect x="106" y="45" width="12" height="8" rx="2" fill="#1f2937" />
            <rect x="108" y="47" width="8" height="4" rx="1" fill="#06b6d4">
              <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite" />
            </rect>
            <rect x="109" y="48" width="3" height="2" fill="#fff" opacity="0.8" />

            <line x1="84" y1="49" x2="92" y2="49" stroke="#22d3ee" strokeWidth="0.5" opacity="0.8">
              <animate attributeName="x1" values="84;92;84" dur="3s" repeatCount="indefinite" />
              <animate attributeName="x2" values="84;92;84" dur="3s" repeatCount="indefinite" begin="0.1s" />
            </line>
            <line x1="108" y1="49" x2="116" y2="49" stroke="#22d3ee" strokeWidth="0.5" opacity="0.8">
              <animate attributeName="x1" values="108;116;108" dur="3s" repeatCount="indefinite" />
              <animate attributeName="x2" values="108;116;108" dur="3s" repeatCount="indefinite" begin="0.1s" />
            </line>
          </g>

          {/* Mouth/Speaker grille */}
          <rect x="88" y="58" width="24" height="8" rx="2" fill="#1f2937" stroke="#4b5563" strokeWidth="1.5" />
          <g opacity="0.7">
            <line x1="90" y1="60" x2="90" y2="64" stroke="#6b7280" strokeWidth="1" />
            <line x1="94" y1="60" x2="94" y2="64" stroke="#6b7280" strokeWidth="1" />
            <line x1="98" y1="60" x2="98" y2="64" stroke="#6b7280" strokeWidth="1" />
            <line x1="102" y1="60" x2="102" y2="64" stroke="#6b7280" strokeWidth="1" />
            <line x1="106" y1="60" x2="106" y2="64" stroke="#6b7280" strokeWidth="1" />
            <line x1="110" y1="60" x2="110" y2="64" stroke="#6b7280" strokeWidth="1" />
          </g>
          <circle cx="100" cy="62" r="2" fill="#10b981" opacity="0.8">
            <animate attributeName="r" values="2;3;2" dur="1s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.8;0.3;0.8" dur="1s" repeatCount="indefinite" />
          </circle>
        </g>

        {/* Left Arm */}
        <g>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 72 85; 15 72 85; -15 72 85; 15 72 85; 0 72 85"
            dur="3s"
            repeatCount="indefinite"
          />
          <rect x="58" y="82" width="16" height="28" rx="4" fill="#e5e7eb" stroke="#1f2937" strokeWidth="2" />
          <line x1="62" y1="85" x2="62" y2="108" stroke="#9ca3af" strokeWidth="1.5" />
          <line x1="70" y1="85" x2="70" y2="108" stroke="#9ca3af" strokeWidth="1.5" />
          <circle cx="66" cy="110" r="5" fill="#374151" stroke="#1f2937" strokeWidth="2" />
          <circle cx="66" cy="110" r="3" fill="#6b7280" />
          <rect x="58" y="112" width="16" height="20" rx="4" fill="#f3f4f6" stroke="#1f2937" strokeWidth="2" />
          <rect x="60" y="115" width="12" height="3" fill="#9ca3af" opacity="0.5" />
          <rect x="60" y="120" width="12" height="3" fill="#9ca3af" opacity="0.5" />
          <g>
            <circle cx="66" cy="132" r="4" fill="#374151" stroke="#1f2937" strokeWidth="2" />
            <g>
              <rect x="64" y="134" width="4" height="10" rx="1" fill="#e5e7eb" stroke="#1f2937" strokeWidth="1.5" />
              <rect x="65" y="135" width="2" height="2" fill="#6b7280" opacity="0.5" />
            </g>
            <g>
              <rect x="60" y="136" width="4" height="12" rx="1" fill="#f3f4f6" stroke="#1f2937" strokeWidth="1.5" />
              <rect x="61" y="137" width="2" height="2" fill="#6b7280" opacity="0.5" />
            </g>
            <g>
              <rect x="68" y="136" width="4" height="12" rx="1" fill="#f3f4f6" stroke="#1f2937" strokeWidth="1.5" />
              <rect x="69" y="137" width="2" height="2" fill="#6b7280" opacity="0.5" />
            </g>
          </g>
        </g>

        {/* Right Arm */}
        <g>
          <animateTransform
            attributeName="transform"
            type="rotate"
            values="0 128 85; -12 128 85; 12 128 85; -12 128 85; 0 128 85"
            dur="3.5s"
            repeatCount="indefinite"
            begin="0.5s"
          />
          <rect x="126" y="82" width="16" height="28" rx="4" fill="#e5e7eb" stroke="#1f2937" strokeWidth="2" />
          <line x1="130" y1="85" x2="130" y2="108" stroke="#9ca3af" strokeWidth="1.5" />
          <line x1="138" y1="85" x2="138" y2="108" stroke="#9ca3af" strokeWidth="1.5" />
          <circle cx="134" cy="110" r="5" fill="#374151" stroke="#1f2937" strokeWidth="2" />
          <circle cx="134" cy="110" r="3" fill="#6b7280" />
          <rect x="126" y="112" width="16" height="20" rx="4" fill="#f3f4f6" stroke="#1f2937" strokeWidth="2" />
          <rect x="128" y="115" width="12" height="3" fill="#9ca3af" opacity="0.5" />
          <rect x="128" y="120" width="12" height="3" fill="#9ca3af" opacity="0.5" />
          <g>
            <circle cx="134" cy="132" r="4" fill="#374151" stroke="#1f2937" strokeWidth="2" />
            <g>
              <rect x="132" y="134" width="4" height="10" rx="1" fill="#e5e7eb" stroke="#1f2937" strokeWidth="1.5" />
              <rect x="133" y="135" width="2" height="2" fill="#6b7280" opacity="0.5" />
            </g>
            <g>
              <rect x="128" y="136" width="4" height="12" rx="1" fill="#f3f4f6" stroke="#1f2937" strokeWidth="1.5" />
              <rect x="129" y="137" width="2" height="2" fill="#6b7280" opacity="0.5" />
            </g>
            <g>
              <rect x="136" y="136" width="4" height="12" rx="1" fill="#f3f4f6" stroke="#1f2937" strokeWidth="1.5" />
              <rect x="137" y="137" width="2" height="2" fill="#6b7280" opacity="0.5" />
            </g>
          </g>
        </g>
      </g>

      {/* Tech Elements & Particles */}
      <g opacity="0.9">
        <circle cx="35" cy="50" r="2" fill="#06b6d4">
          <animate attributeName="cy" values="50;30;50" dur="3s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.4;1;0.4" dur="3s" repeatCount="indefinite" />
        </circle>
        <circle cx="165" cy="60" r="2.5" fill="#10b981">
          <animate attributeName="cy" values="60;40;60" dur="2.5s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.3;1;0.3" dur="2.5s" repeatCount="indefinite" />
        </circle>
        <circle cx="30" cy="100" r="2" fill="#a855f7">
          <animate attributeName="cy" values="100;80;100" dur="3.5s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.5;1;0.5" dur="3.5s" repeatCount="indefinite" />
        </circle>
        <circle cx="170" cy="110" r="2.5" fill="#f59e0b">
          <animate attributeName="cy" values="110;90;110" dur="2.8s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.4;1;0.4" dur="2.8s" repeatCount="indefinite" />
        </circle>
      </g>

      {/* Circuit board traces */}
      <g opacity="0.3" stroke="#6b7280" strokeWidth="1.5" fill="none">
        <path d="M20 30 L40 30 L40 50">
          <animate attributeName="stroke-opacity" values="0.3;0.7;0.3" dur="2s" repeatCount="indefinite" />
        </path>
        <path d="M180 40 L160 40 L160 60">
          <animate attributeName="stroke-opacity" values="0.3;0.7;0.3" dur="2.5s" repeatCount="indefinite" begin="0.5s" />
        </path>
        <circle cx="40" cy="50" r="2" fill="#06b6d4" />
        <circle cx="160" cy="60" r="2" fill="#10b981" />
      </g>

      {/* Energy indicators */}
      <g>
        <rect x="25" y="80" width="3" height="12" rx="1.5" fill="#1f2937" opacity="0.5" />
        <rect x="25" y="88" width="3" height="4" fill="#10b981">
          <animate attributeName="y" values="92;80;92" dur="2s" repeatCount="indefinite" />
          <animate attributeName="height" values="0;12;0" dur="2s" repeatCount="indefinite" />
        </rect>
        <rect x="172" y="80" width="3" height="12" rx="1.5" fill="#1f2937" opacity="0.5" />
        <rect x="172" y="88" width="3" height="4" fill="#06b6d4">
          <animate attributeName="y" values="92;80;92" dur="2.5s" repeatCount="indefinite" />
          <animate attributeName="height" values="0;12;0" dur="2.5s" repeatCount="indefinite" />
        </rect>
      </g>

      {/* Gradients and Filters */}
      <defs>
        <filter id="robotShadow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
          <feOffset dx="2" dy="3" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.4" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
        <linearGradient id="robotBodyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f9fafb" />
          <stop offset="50%" stopColor="#e5e7eb" />
          <stop offset="100%" stopColor="#d1d5db" />
        </linearGradient>
        <linearGradient id="robotHeadGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="50%" stopColor="#f3f4f6" />
          <stop offset="100%" stopColor="#e5e7eb" />
        </linearGradient>
        <linearGradient id="panelGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#f3f4f6" />
          <stop offset="50%" stopColor="#d1d5db" />
          <stop offset="100%" stopColor="#9ca3af" />
        </linearGradient>
        <radialGradient id="coreGradient">
          <stop offset="0%" stopColor="#06b6d4" />
          <stop offset="50%" stopColor="#0891b2" />
          <stop offset="100%" stopColor="#164e63" />
        </radialGradient>
        <radialGradient id="shadowGradient">
          <stop offset="0%" stopColor="#000" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#000" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  )
}
